/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  ConfiguredWallAlignmentInDTO,
  HTTPValidationError,
  TaskResponseDTO,
} from '../fastAPI.schemas'

/**
 * @summary Start configured wall alignment
 */
export const startConfiguredWallAlignment = (
  projectGuid: string,
  wallGuid: string,
  configuredWallAlignmentInDTO: ConfiguredWallAlignmentInDTO,
  signal?: AbortSignal,
) => {
  return customInstance<TaskResponseDTO>({
    url: `/projects/${projectGuid}/planar-model/walls/${wallGuid}/configured-alignment`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: configuredWallAlignmentInDTO,
    signal,
  })
}

export const useStartConfiguredWallAlignmentMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startConfiguredWallAlignment>>,
    TError,
    { projectGuid: string; wallGuid: string; data: ConfiguredWallAlignmentInDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof startConfiguredWallAlignment>>,
  TError,
  { projectGuid: string; wallGuid: string; data: ConfiguredWallAlignmentInDTO },
  TContext
> => {
  const mutationKey = ['startConfiguredWallAlignment']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startConfiguredWallAlignment>>,
    { projectGuid: string; wallGuid: string; data: ConfiguredWallAlignmentInDTO }
  > = props => {
    const { projectGuid, wallGuid, data } = props ?? {}

    return startConfiguredWallAlignment(projectGuid, wallGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/planar-model/walls/{wallGuid}/configured-alignment` },
    {
      operationId:
        'start_configured_wall_alignment_projects__project_guid__planar_model_walls__wall_guid__configured_alignment_post',
      operationName: 'startConfiguredWallAlignment',
    },
  )

  return customOptions
}

export type StartConfiguredWallAlignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof startConfiguredWallAlignment>>
>
export type StartConfiguredWallAlignmentMutationBody = ConfiguredWallAlignmentInDTO
export type StartConfiguredWallAlignmentMutationError = HTTPValidationError

/**
 * @summary Start configured wall alignment
 */
export const useStartConfiguredWallAlignment = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startConfiguredWallAlignment>>,
    TError,
    { projectGuid: string; wallGuid: string; data: ConfiguredWallAlignmentInDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof startConfiguredWallAlignment>>,
  TError,
  { projectGuid: string; wallGuid: string; data: ConfiguredWallAlignmentInDTO },
  TContext
> => {
  const mutationOptions = useStartConfiguredWallAlignmentMutationOptions(options)

  return useMutation(mutationOptions)
}
